import { React, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "./footer";
import Menu from "./menu";
import SubMenu from "./subMenu";
import { useSelector } from "react-redux";


/**
 * This component renders the side bar of the application.
 * It contains the main menu and a sub menu. The main menu
 * is rendered by the `Menu` component and the sub menu is
 * rendered by the `SubMenu` component.
 * 
 * This component uses the `useSelector` hook to get the state of the menu
 * from the Redux store and based on that state it shows or hides the menu.
 * 
 * The main menu is rendered in a `Col` component with a class of `main-menu`
 * and the sub menu is rendered in a `Col` component with a class of `sub-menu`.
 * 
 * The content of the sub menu is rendered in a `div` component with a class
 * of `sub-menu-content` and the footer of the side bar is rendered in a `div`
 * component with a class of `sidebar-footer`.
 * 
 * @returns A JSX element that renders the side bar of the application.
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com> 2024/05/12
 */


export default function SideBar() {
  const menu = useSelector((state) => state.menu);


  return (
    <Container> 
      <Row className="">
        <Col sm={2} className={menu.display ? "main-menu " : "h"} id="">
          <Menu />
        </Col>

        <Col sm={10} className="sub-menu">
          <div id="" className="sub-menu-content  ">
            <SubMenu />
          </div>
          <div className="sidebar-footer">
            <Footer islogin={true} />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
